import {useCallback, useEffect, useState, useRef} from 'react'
import Table from "../Components/Table/Table";
import {Link} from "react-router-dom";
import {Api} from "../../../helpers/Api";
import Heading from "../Components/Heading/Heading";
import columnConfig from "../Main/Dashboard/columns";
import {connect} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import Popup from "../Components/PopUp/Popup";
import SearchUI from '../Search/SearchUI';
import ExportMetaData from '../Main/ExportMetaData/ExportMetaData'
import DeleteModal from '../Components/Deletemodal/DeleteModal';

const PastEvent = ({user, ...props}) => {
    const params = useParams();
    let tableRef = new Table();
    const navigate = useNavigate();
    const [ del, setDel ] = useState(false);
    const [ id, setId ] = useState();

    params.path = 'template_4';
    const config = columnConfig['template_4'];
    const [ filterData, setFilterData ] = useState([]);
    const [ state, setState ] = useState({
        loading: true,
        error: null,
        config: config,
        page: 1,
        limit: 10,
        total: 0,
        show: false,
        search:true,
        showSearch:false
    });
    
    const [filter,setFilter] = useState(null);
    const [posts, setPosts] = useState([]);
    const [total, setTotal] = useState(-1);  

    const clearFilter = () =>{
        if(filter == null){
            localStorage.removeItem(`data`);
            loadData();
        }
        else{
            localStorage.removeItem(`data`);
            setFilter(null);
            setFilterData([]);
        }
    }

    const loadData = useCallback(() => {
        setState(s => {
            return {...s, loading: true}
        });
        let start = 0;  
        const limit = state.limit;
        const page = state.page;
        let today = new Date();
        let month = `${today.getMonth()+1}`;
        let Day = `${today.getDate()}`;
        if(month.length <= 1)
        {
            month = '0'+month;
        }
        if(Day.length <= 1)
        {
            Day = '0'+Day;
        }
        let date = today.getFullYear()+'-'+month+'-'+Day;
        start = (page - 1) * limit;
        // Api.call(`/${config.url}/count`).then(response => {
        //     setTotal(0);
        // });
        let Sdata = localStorage.getItem("data");
        if((filter && filter.query) || (Sdata != "" && Sdata)){
                if(filterData.selector === "date"){
                    if(filter){
                        localStorage.setItem("data",`/getpostEvent?_sort=start_date:DESC&_limit=${limit}&_start=${start}&${filter.query}`)
                    }
                    let data = localStorage.getItem("data");
                Api.call(`${data}`).then(response => {
                    setTotal(response[response.length - 1]);
                    let d = [];
                    d = response;
                    d.splice(response.length-1,1)
                    setPosts(d)  
                }).catch(console.log).finally(_ => {
                    setState(s => {
                        return {...s, loading: false}
                    });
                });
            }
            else{
                if(filter){
                    localStorage.setItem("data",`/getpostEvent?end_date_lte=${date}&_sort=start_date:DESC&_limit=${limit}&_start=${start}&${filter.query}`)
                }
                let data = localStorage.getItem("data");
                Api.call(data).then(response => {
                setTotal(response[response.length - 1]);
                let d = [];
                d = response;
                d.splice(response.length-1,1)
                setPosts(d)  
            }).catch(console.log).finally(_ => {
                setState(s => {
                    return {...s, loading: false}
                });
            });
        }
        }
        else{
        Api.call(`/getpostEvent?end_date_lte=${date}&_sort=start_date:DESC&_limit=${limit}&_start=${start}`).then(response => {
            setTotal(response[response.length - 1]);
            let d = [];
            d = response;
            d.splice(response.length-1,1)
            setPosts(d)
        }).catch(console.log).finally(_ => {
            setState(s => {
                return {...s, loading: false}
            });
        });}
    }, [config.url, state.page, filter, state.limit]);

    const onPaginate = (page) => {
        setState({...state, page: page, loading: true})
    };

    useEffect(() => {
        if (!user) {
            return;
        }
        if(user?.user?.role === 12 || user?.user?.role === 13 ){
            navigate('/ReportRoleWise');
        }
        loadData()
    }, [loadData, params.path, user]);

    const parsePatient = (post) => {
        let row = state.config.columns.map((column) => {
            if (column.accessor) {
                return column.accessor(post);
            }
            return post[column.key];
        });
        return row;
    };

    const renderRow = (row, index) => {
        let columnIndex = 0;
        let patient = parsePatient(row);
        return <tr key={index}>
            <td key={index}>{`${(state.page - 1) * state.limit+(index+1)}`}</td>
            {patient.map(column => {
                return renderColumn(column, columnIndex++, index, patient, row);
            })}</tr>
    };

    const selectAll = () => {
        let allSelected = !state.allSelected;
        let row = state.row.map(patient => {
            patient.selected = allSelected;
            return patient;
        });
        setState({...state, row: row, allSelected: allSelected});
    };

    const onDelete = (event, index) => {
        setState(s => {
            return {...s, loading: true}
        });
        event.preventDefault();
        let post = posts[index];
        setDel(false);
        Api.call(`/${config.url}/${post.id}`, "DELETE").then(response => {
            loadData();
        })
    };

    const onUp = (event, index) => {
        event.preventDefault();
        setState({...state, loading: true})
        let post = posts[index];
        Api.call(`/${config.url}/${post.id}/move/up`, "POST").then(response => {

        }).catch(() => {

        }).finally(loadData)
    };

    const onDown = (event, index) => {
        setState({...state, loading: true})
        event.preventDefault();

        let post = posts[index];
        Api.call(`/${config.url}/${post.id}/move/down`, "POST").then(response => {

        }).catch(() => {

        }).finally(loadData)
    };

    const showSearchbox = (boolean) =>{
        setState(s =>{
           return { ...s, showSearch:boolean }
        })
    }

    const filterBuilder = (query) =>{
        setFilter(query); 
    }

    const renderColumn = (column, index, rowIndex, row, originalRow) => {
        if (index === row.length - 1) {

            if (state.config.renderActions) {
                return state.config.renderActions(column, index, rowIndex, row, originalRow, onUp , onDown,onDelete, state, config);
            }
            else {
                return <td key={index}>
                <ul>
                    <li>                          
                        <Link to={`/${config.url_2}/${originalRow.id}`}>
                        {columnConfig.editIcon}
                        </Link>
                    </li>
                    <li>
                        {/* e => onDelete(e, rowIndex) */}
                        <Link to="" onClick={()=>{setDel(true); setId(rowIndex)}}>
                           {columnConfig.deleteIcon}
                        </Link>
                    </li>
                </ul>
            </td>
        }
        }
        if (typeof column === "boolean") {
            return <td key={index}><span style={{color: column ? "green" : "red"}}>{column ? "Yes" : "No"}</span></td>
        }
        // console.log("Rendering ", column)
        return <td key={index}>{column}</td>
    };
    const renderHeaderColumn = (column, index) => {

        return (
            <th key={index}>
                {column.name}
            </th>
        );
    };

    const onclick = () =>{
        tableRef.export(ExportMetaData.PastEvent,posts)
    }

    // if(state.loading === false && posts.length === 0)
    // {
    //     return (
    //         <div className="right_container">
    //             <div className="dashboard">
    //                 <div className='inner-content'>
    //                     <div className="heading-for-certificate">
    //                         <h2>{`Events`}</h2>
    //                         <p>
    //                             There are no events created yet.
    //                             Start adding events by clicking on add new event. 
    //                         </p>
    //                         <ul>
    
    //                             <li>
    //                                 <Link to={`/${config.url}/new`}>
    //                                     <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" aria-hidden="true" focusable="false" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path></svg>
    //                                     Add New
    //                                 </Link>
    //                             </li> 
    //                         </ul>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //     )
    // }
    return (
        <div className="right_container">
            <Popup trigger={del} icon='../../../../images/delete-icon.svg' actionParams={id} action={onDelete} class="delete-popup" setSearch={setDel}>
               <DeleteModal/>
            </Popup>
            <Popup trigger={state.showSearch} okBtn={true} setSearch={showSearchbox} heading={<div className='search'><h5 className="search-title">Filter</h5>
                                                                                <p>Please search here by fields name.</p></div>}>
                <SearchUI filterBuilder={filterBuilder} data={filterData} setData={setFilterData} name="PastEvent"></SearchUI>
            </Popup>
            <div className="dashboard">
                <div className='inner-content'>
                    
                    <Heading name={config.name} lonRefresh={clearFilter} export={onclick} search={true} query={"data"} setSearchBox={showSearchbox} refreshlink="#" link={`/${config.url}/new`}
                            linkName="Add New" url={params.path} total={total}  />
                        
                    <div className='commen-table'>
                        <Table serial={true} ref={tableRef} renderColumn={renderColumn}  loading={state.loading}
                            renderRow={renderRow} renderHeaderColumn={renderHeaderColumn} 
                            columns={state.config.columns} cardFooter="cardFooter" total={total}     
                            currentPage={state.page} perPage={state.limit} filter={localStorage.getItem("data") ? {"query":true} : filter}
                            rows={posts} selected="Invite Selected" onPaginate={onPaginate}
                            onChangePerPage={(limit) => {
                            setState({...state, limit});
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatchLogin: (user) => dispatch({type: 'LOGIN', data: user})
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PastEvent)
